import { TenantType } from "@constants/types/TenantType";
import Joi from "joi";

export const JoiTenantScheme = Joi.object({
  all_restaurants: Joi.boolean().optional(),
  app_bundle_id: Joi.string().required().allow(""),
  apple_team_id: Joi.string().required().allow(""),
  external_payment_allowed: Joi.boolean().optional(),
  external_push_allowed: Joi.boolean().optional(),
  id: Joi.number().required(),
  name: Joi.string().required().allow(""),
  organization_id: Joi.number().required().allow("").default(0),
  simple_user_auth_allowed: Joi.boolean().optional(),
  status: Joi.boolean().optional(),
  type: Joi.number()
    .valid(TenantType.Dook, TenantType.MiniAG, TenantType.ExternalIntegrator)
    .default(TenantType.MiniAG),
  webhook_url_push: Joi.string().required().allow(""),
  webhook_url_refund: Joi.string().required().allow(""),
});
